import { TFunction } from 'i18next';
import { LicenseSystemSubscriptionErrorTypes } from 'src/viewModels/LicenseSystem';

export function getErrorMsgForToast(response: any, t: (labelKey: string, defaultValue: string) => string) {
    // this is the blueprint for the new way of error handling in toasts
    const errorText = response.errors[0].errorInfo || t('Common.Toast.Error', 'An error occurred');
    return `${errorText} (Error-ID: ${response.errors[0].message})`;
};


export const getErrorMsgFromLicenseSystemSubscription = (errorType: LicenseSystemSubscriptionErrorTypes, licenseSystemId: string | undefined, translate: TFunction<'translation', undefined>) => {

    switch (errorType) {
        case 'ReactivationLimitReached':
            return translate('LicenseSystemSubscriptionError.access_denied_desc', {
                defaultValue: 'Limit was reached for License System "{{licenseSystemId}}". Please contact GMG Support.',
                licenseSystemId: licenseSystemId ?? 'unknown',
            });
        case 'AssignedToDifferentOrg':
            return translate('LicenseSystemSubscriptionError.assigned_to_different_org_desc', 'The license system is owned by a different organization.');
        case 'OLSExistsWithDiffSrNo':
        case 'OLSExistsWithSameSrNo':
            return translate('LicenseSystemSubscriptionError.ols_exists_desc', 'License system already exists.');
        case 'AutomatedLicenseTransferDeactivated':
            return translate('LicenseSystemSubscriptionError.blacklisted_accoount_desc', 'Automated updates are deactivated for your organization.');
        default:
            return translate('Common.Toast.Error', 'An error occurred.');
    }
};